import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold py-3" }, "Edit organization details")
], -1)
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "w-full flex flex-row justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
      class: "p-3"
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextField, {
          modelValue: _ctx.companyName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event)),
          label: "Company name",
          typeInput: "text",
          name: "visible_name"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SelectDropdown, {
          modelValue: _ctx.company_industry_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company_industry_id) = $event)),
          options: _ctx.companyIndustries,
          label: "Company industry",
          name: "company_industry_id"
        }, null, 8, ["modelValue", "options"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFields, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex flex-col mb-6"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TextField, {
              modelValue: item.model,
              "onUpdate:modelValue": ($event: any) => ((item.model) = $event),
              label: item.label,
              typeInput: item.type,
              name: item.name
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "typeInput", "name"])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: "Cancel",
            variant: "outlined",
            onOnClick: _ctx.close
          }, null, 8, ["onOnClick"]),
          _createVNode(_component_Button, {
            disabled: _ctx.isLoading,
            label: _ctx.isLoading ? 'Saving changes...' : 'Save',
            variant: "contained",
            onOnClick: _ctx.onSubmit
          }, null, 8, ["disabled", "label", "onOnClick"])
        ])
      ])
    ], 32)
  ]))
}